import React from "react";
import PropTypes from "prop-types";
import { Form } from "formik";
import { Grid } from "@material-ui/core";
import PlaceIcon from "@material-ui/icons/Place";
import { useIntl } from "react-intl";

import OrganizacaoEditFormBase from "./Base";
import { LeadEnderecoForm } from "../../../pages/lead/components";
import { Flex, Tipografia } from "../../../_common";

import OrganizacaoEditFormCamposPersonalizados from "../EditForm/CamposPersonalizados";

function OrganizacaoEditForm({ ...props }) {
  const intl = useIntl();

  return (
    <Form id="form-cadastro-organizacao-lead" noValidate>
      <OrganizacaoEditFormBase {...props} />
      <Grid container spacing={16}>
        <Grid item xs={12}>
          <Flex style={{ marginTop: 16, marginBottom: 8 }}>
            <PlaceIcon style={{ marginRight: 8, marginLeft: -6 }} />
            <Tipografia cor="darkSecondaryText" tipo="tituloCard">
              {intl.formatMessage({ defaultMessage: "Endereço" })}
            </Tipografia>
          </Flex>
        </Grid>
        <Grid item xs={12}>
          <LeadEnderecoForm />
        </Grid>
        {!props.isEmpresaOrganizacao &&
          props.initialValues.camposPersonalizados &&
          props.initialValues.camposPersonalizados.length > 0 && (
            <Grid item xs={12}>
              <div>
                <Flex flexDirection="column">
                  <Tipografia cor="darkSecondaryText" tipo="tituloCard">
                    {intl.formatMessage({ defaultMessage: "Campos Personalizados" })}
                  </Tipografia>
                  <OrganizacaoEditFormCamposPersonalizados campos={props.initialValues.camposPersonalizados} />
                </Flex>
              </div>
            </Grid>
          )}
      </Grid>
    </Form>
  );
}

OrganizacaoEditForm.propTypes = {
  isEmpresaOrganizacao: PropTypes.bool,
  initialValues: PropTypes.object,
  camposPersonalizados: PropTypes.object,
};

export default OrganizacaoEditForm;
